import { motion } from 'motion/react';
import styled from 'styled-components';
import { shapes, scrollerTypes } from '.';
import Button from '../Button';

export const ScrollerButton = styled(Button)`
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: var(--spacing-16);
  right: var(--spacing-16);
  z-index: 3;
`;

export const Frame = styled.div<{ shape?: shapes; type: scrollerTypes }>`
  aspect-ratio: var(--ratio);
  align-items: center;
  display: flex;
  overflow: hidden;
  position: relative;
  transition: width 0.6s cubic-bezier(0.75, 0, 0.25, 1);
  transition-delay: 0.4s;
  will-change: width;
  width: var(--width);

  ${({ type }) =>
    type === 'double' &&
    `
          flex-shrink: 0;
          border-radius: var(--radius-md);
      `}

  ${({ shape }) =>
    shape === 'round' &&
    `
          border-radius: 100%;
          grid-row:span 2;
      `}
    ${({ shape }) =>
    shape === 'vertical' &&
    `
          grid-row:span 2;
      `}
    ${({ shape }) =>
    shape === 'horizontal-pill' &&
    `
          border-radius: var(--radius-full);
          grid-row:span 1;
      `}
    ${({ shape }) =>
    shape === 'horizontal' &&
    `
          grid-row:span 1;
      `}
    ${({ shape }) =>
    (shape === 'vertical' || shape === 'horizontal') &&
    `
          border-radius: var(--radius-md);
      `}

    & > picture,
    & img,
    & > mux-player {
    block-size: 100%;
    inline-size: 100%;
    object-fit: cover;
    transition: transform 0.6s cubic-bezier(0.75, 0, 0.25, 1);
    will-change: transform;
  }

  @media (hover: hover) {
    &:has(mux-player):hover,
    &:is(a):hover {
      cursor: pointer;
      width: calc(var(--width) * 1.2);

      > picture,
      > img,
      > mux-player {
        transform: scale(1.05);
      }
    }
  }
`;

export const ScrollerWrapper = styled(motion.div)<{
  type: scrollerTypes;
}>`
  position: relative;
  display: flex;
  white-space: nowrap;
  gap: var(--spacing-16);

  ${({ type }) =>
    type === 'double' &&
    `
        &:nth-child(1) {
          align-items: end;
        }
        &:nth-child(2) {
          align-items: start;
        }
    `}

  ${({ type }) =>
    type === 'simple' &&
    `
          display: inline-grid;
          grid-auto-flow: column;
          grid-template-rows: 1fr 1fr;
          gap: var(--spacing-16);
          align-items: center;
      `}
`;
